<template>
    <div style="margin: 10px">
        <v-form>
            <v-card>
                <div class="headline dialog-header">
                    <v-toolbar color="primary" dark>
                        <v-toolbar-title style="padding-left: 10px"
                            >{{ $t(formName) }}
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-btn
                        @click="onCancel"
                        icon
                        style="
                            position: absolute;
                            right: 10px;
                            top: 10px;
                            color: #fff;
                        "
                    >
                        <v-icon>cancel</v-icon>
                    </v-btn>
                </div>
                <v-card-text>
                    <v-layout wrap style="padding: 10px;">
                        <v-flex xs12 sm12 md6>
                            <p class="font-weight-bold">
                                Mã quản lý:
                                {{ fixedAssets.code }}
                            </p>
                            <p class="font-weight-bold">
                                Tên tài sản:
                                {{ fixedAssets.name }}
                            </p>
                        </v-flex>
                        <v-flex xs12 sm12 md6>
                            <p class="font-weight-bold">
                                Bộ phận sử dụng hiện tại:
                                {{ getDepartmentName() }}
                            </p>
                            <p class="font-weight-bold">
                                Địa điểm sử dụng hiện tại:
                                {{ getLocationName() }}
                            </p>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-text>
                    <table class="lstTable" v-if="lstHistory.length > 0">
                        <tr>
                            <th width="10%">Ngày xuất kho đi sửa</th>
                            <th width="10%">Ngày nhận</th>
                            <th width="10%">Đơn vị sửa chữa</th>
                            <th width="15%">Nộ dung sửa chữa</th>
                            <th width="10%">Chi phí sửa chữa</th>
                            <th width="10%">Bảo hành sửa chữa</th>
                            <th width="10%">Tình trạng sau sửa chữa</th>
                            <th width="15%">Ghi chú</th>
                            <th width="10%">Hành động</th>
                        </tr>
                        <template v-for="(item, k) in lstHistory">
                            <tr :key="k">
                                <td style="text-align: center;">{{item.repairDate|formatDate}}</td>
                                <td style="text-align: center;">{{item.receiveDate|formatDate}}</td>
                                <td>{{item.repairUnitName}}</td>
                                <td>{{item.content}}</td>
                                <td style="text-align: right;">{{item.repairCost|currency}}</td>
                                <td style="text-align: center;">{{item.repairWarranty|formatDate}}</td>
                                <td>{{item.receiveStatus}}</td>
                                <td>{{item.note}}</td>
                                <td style="text-align: center;">
                                    <v-btn icon @click="openCreateDialog(item)">
                                        <v-icon color="primary">edit</v-icon>
                                    </v-btn>
                                    <v-btn icon @click="deleteItem(item)">
                                        <v-icon color="red">delete</v-icon>
                                    </v-btn>
                                </td>
                            </tr>
                        </template>
                        <tr>
                            <td colspan="3"></td>
                            <td style="text-align: center;"><strong>Tổng</strong></td>
                            <td style="text-align: right;"><strong>{{totalRepairCost()|currency}}</strong></td>
                            <td colspan="4"></td>
                        </tr>
                    </table>
                    <div v-else style="border:1px solid grey;border-radius: 10px;padding: 10px">Không có lịch sử
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <!-- <v-btn color="primary" @click="openCreateDialog()" :disabled="loading">
                        {{ $t("lang.common.add") }}
                    </v-btn> -->
                    <v-btn color="warning" @click="onCancel" :disabled="loading">
                        {{ $t("lang.common.return") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
        <repair-edit
            :propsItem="repairItem"
            :cDialog="visibleCreateDialog"
            @closeCreateDialog="closeCreateDialog"
            :fixedAssetsId="fixedAssets.id"
        />
    </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import IDatepicker from "../../../components/form/DatePicker";
import { message } from "../../../shared/message";
import CTextboxFloat from "@/components/form/TextboxFloat";
import RepairEdit from "./RepairEdit.vue";

export default {
    name: "fixed-assets-repair-create",
    components: {CTextboxFloat, IDatepicker, RepairEdit },
    data: () => {
        return {
            formName: "Khai báo sữa chữa",
            loading: false,
            locationCurrentName: '',
            departmentCurrentName: '',
            lstLocation: [],
            lstDepartment: [],
            lstHistory: [],
            fixedAssets: {
                code: '',
                name: '',
                departmentId: '',
                locationId: '',
                id: 0,
            },
            visibleCreateDialog: false,
            repairItem: null,
        };
    },

    created() {
        const role = parseInt(this.$store.state.auth.user.role);
        
        const queryParam = this.$route.query;

        this.getLocation();
        this.getDepartment();

        if (queryParam.fixedAssetsId != undefined) {
            this.getFixedAssets(queryParam.fixedAssetsId);
            this.getHistory(queryParam.fixedAssetsId);
        }

    },
    computed: {
        
    },
    methods: {
        openCreateDialog: function (item = null) {
            console.log(item);
            this.repairItem = item;
            this.visibleCreateDialog = true;
        },
        closeCreateDialog() {
            this.repairItem = null;
            this.visibleCreateDialog = false;
            this.getHistory(this.fixedAssets.id);
        },
        onCancel() {
            const query = this.$route.query;
            if (query.backTo != undefined && query.backTo == 'fixedAssetsReport') {
                this.$router.push({ path: `/fixedAssetsReport`, query: query });
            } else {
                this.$router.push({ path: `/fixedAssetsRepair`, query: query });
            }
        },
        getLocation() {
            axios.post(
                process.env.VUE_APP_API_URL + "/category/listByType?type=OFFICE_LOCATION"
            ).then(
                (data) => {
                    if (data.length > 0) {
                        this.lstLocation = data;
                    }
                }
            );
        },
        getDepartment() {
            axios.post(
                process.env.VUE_APP_API_URL + "/department/search?pageSize=-1&page=-1", {}
            ).then(
                (data) => {
                    if (data.items) {
                        this.lstDepartment = data.items;
                    }
                }
            );
        },
        getFixedAssets(fixedAssetsId) {
            axios.post(
                process.env.VUE_APP_API_URL + "/fixedAssets/search?pageSize=-1&page=-1",
                { id: fixedAssetsId }
            )
            .then((data) => {
                if (data.items) {
                    this.fixedAssets = data.items[0];
                }
            });
        },
        getHistory(fixedAssetsId) {
            axios.post(process.env.VUE_APP_API_URL + "/fixedAssetsRepair/search?pageSize=-1&page=-1&sortField=repairDate&orderBy=desc", {fixedAssetsId: fixedAssetsId})
            .then(
                (data) => {
                    if (data.items) {
                        this.lstHistory = data.items;
                    }
                }
            );
        },
        totalRepairCost() {
            let total = 0;
            for (let i = 0; i < this.lstHistory.length; i++) {
                total += this.lstHistory[i].repairCost;
            }
            return total;
        },
        getDepartmentName() {
            let departmentName = '';
            const department = this.lstDepartment.find(o => o.deptId === this.fixedAssets.departmentId );
            if (department !== undefined && typeof department == 'object') {
                departmentName = department.deptName;
            }
            return departmentName;
        },
        getLocationName() {
            let locationName = '';
            const location = this.lstLocation.find(o => o.categoryId === this.fixedAssets.locationId );
            if (location !== undefined && typeof location == 'object') {
                locationName = location.categoryName;
            }
            return locationName;
        },
        deleteItem(item) {
            if (confirm(this.$t("lang.common.deleteConfirm"))) {
                this.loading = true;
                axios
                    .post(process.env.VUE_APP_API_URL + "/fixedAssetsRepair/delete", item)
                    .then(
                        (data) => {
                            if (data) {
                                message.success(this.$t("lang.common.delete_success"));
                                this.getHistory(this.fixedAssets.id);
                            } else {
                                message.error(this.$t("lang.common.deleteError"));
                            }
                            this.loading = false;
                        },
                        (error) => {
                            this.loading = false;
                            console.log(error);
                        }
                    );    
            }
        },
    },

    destroyed() {},
};
</script>
